import { msg } from '@lingui/core/macro';
import type { NotificationType } from '@shared/model/alert.slice.ts';
import { translateItem } from '@utils/translations.ts';

export const ALERT_STATUSES = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
} as const;

export const AlertNotifications: Record<NotificationType, { message: string }> = {
    [ALERT_STATUSES.INFO]: {
        get message() {
            return translateItem(msg`This is an info message`);
        },
    },
    [ALERT_STATUSES.SUCCESS]: {
        get message() {
            return translateItem(msg`Success`);
        },
    },
    [ALERT_STATUSES.WARNING]: {
        get message() {
            return translateItem(msg`This is a warning message`);
        },
    },
    [ALERT_STATUSES.ERROR]: {
        get message() {
            return translateItem(msg`Oops, something went wrong.`);
        },
    },
};
